import React from 'react'
import { FilterName, FilterParam } from '../FilterBar.types'
import { GenericFilterDropdown } from './GenericFilterDropdown'

export const AccountTypeFilterDropdown = ({
  isNested = false,
}: {
  isNested?: boolean
}): JSX.Element => (
  <GenericFilterDropdown
    filterParam={FilterParam.ACCOUNT_TYPE}
    filterName={FilterName.ACCOUNT_TYPE}
    valueKey="accountTypes"
    isNested={isNested}
  />
)
